var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat304(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_304"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_304",
    "data-name": 304,
    className: "cls-2",
    d: "M37.34,13.14a23.56,23.56,0,0,0-20.33,0C5,19,1.71,35.13,3,47.3,5.57,72,28.66,87.11,51.65,89.58A82.45,82.45,0,0,0,83.06,87c4.55-1.31,13.68-3.7,15.23-9.08,0-.11,0-.24.06-.36C99,70.8,73,72.69,57.68,50.42,46.85,34.68,50.07,19.55,37.34,13.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat304);
export default __webpack_public_path__ + "static/media/cat_304.2936554b5496cd641aa7b2b2a57e2d6c.svg";
export { ForwardRef as ReactComponent };